export default "<span class='loading-animator'></span>";